/**
 * 员工管理
 */
const SataffRouter = {
  path: '/staff',
  component: () => import('@/views/layout'),
  redirect: '/staff/manage/list',
  meta: {
    title: '员工管理',
    icon: require('@/assets/slider/management.png')
  },
  alwaysShow: true,
  children: [
    {
      path: 'manage/list',
      name: 'EmpManageList',
      component: () => import('@/views/emp_manage'),
      meta: {
        title: '员工列表',
        keepAlive: true
      }
    },
    {
      path: 'separation/list',
      name: 'SeparationList',
      component: () => import('@/views/separation_list'),
      meta: {
        title: '离职列表',
        keepAlive: true
      }
    },
    {
      path: 'office/list',
      name: 'OfficeList',
      component: () => import('@/views/office_list'),
      meta: {
        title: '办公室人员',
        keepAlive: true
      }
    },
    {
      path: 'leave/list',
      name: 'EmployeesLeave',
      component: () => import('@/views/employees_leave'),
      meta: {
        title: '员工请假',
        keepAlive: true
      }
    }
    // {
    //   path: 'new_add',
    //   name: 'new_employees',
    //   hidden: true,
    //   component: () => import('@/views/emp_manage/new_employees'),
    //   meta: {
    //     title: '录入新员工'
    //   }
    // },
    // {
    //   path: 'edit/:id',
    //   name: 'employees_edit',
    //   hidden: true,
    //   component: () => import('@/views/emp_manage/new_employees'),
    //   meta: {
    //     title: '编辑员工'
    //   }
    // },
    // {
    //   path: 'detail/:id',
    //   name: 'employee_details',
    //   hidden: true,
    //   component: () => import('@/views/emp_manage/employee_details'),
    //   meta: {
    //     title: '员工详情'
    //   }
    // },
    // {
    //   path: 'audit_desc/:id',
    //   name: 'audit_staff',
    //   hidden: true,
    //   component: () => import('@/views/emp_manage/audit_staff'),
    //   meta: {
    //     title: '审核员工'
    //   }
    // },
    // {
    //   path: 'interview/list',
    //   name: 'Interviewers',
    //   component: () => import('@/views/Interviewers'),
    //   meta: {
    //     title: '面试列表'
    //   }
    // },

    // {
    //   path: 'interview/detail/:id',
    //   name: 'interview_details',
    //   hidden: true,
    //   component: () => import('@/views/Interviewers/interview_details'),
    //   meta: {
    //     title: '申请面试人员详情'
    //   }
    // },
    // {
    //   path: 'separation/apply/detail/:id',
    //   name: 'staff_apply_details',
    //   hidden: true,
    //   component: () => import('@/views/separation_list/details/apply_details'),
    //   meta: {
    //     title: '详情'
    //   }
    // },
    // {
    //   path: 'separation/join/detail/:id',
    //   name: 'staff_join_details',
    //   hidden: true,
    //   component: () => import('@/views/separation_list/details/join_details'),
    //   meta: {
    //     title: '详情'
    //   }
    // },
    // {
    //   path: 'separation/leave/detail/:id',
    //   name: 'staff_leave_details',
    //   hidden: true,
    //   component: () => import('@/views/separation_list/details/leave_details'),
    //   meta: {
    //     title: '详情'
    //   }
    // },
    // {
    //   path: 'separation/reject/detail/:id',
    //   name: 'staff_reject_details',
    //   hidden: true,
    //   component: () => import('@/views/separation_list/details/reject_details'),
    //   meta: {
    //     title: '详情'
    //   }
    // },

    //   children: [
    //     {
    //       path: '',
    //       components: {
    //         wait: () => import('@/views/staff/components/staff_q_wait'),
    //         giveup: () => import('@/views/staff/components/staff_q_giveup'),
    //         already: () => import('@/views/staff/components/staff_q_already')
    //       },
    //       meta: {
    //         title: '面试列表', icon: require('@/assets/slider/management.png')
    //       }
    //     }

    //   ]
    // }

    // {
    //   path: 'staffentry/:status',
    //   component: () => import('@/views/staff/staffentry'),
    //   meta: {
    //     title: '入职管理'
    //   },
    //   children: [
    //     {
    //       path: '',
    //       components: {
    //         examine: () => import('@/views/staff/components/staff_e_examine'),
    //         adopt: () => import('@/views/staff/components/staff_e_adopt'),
    //         reject: () => import('@/views/staff/components/staff_e_reject')
    //       }
    //     }
    //   ]
    // }, {
    //   path: 'staffquit/:status',
    //   component: () => import('@/views/staff/staffquit'),
    //   meta: {
    //     title: '离职管理'
    //   },
    //   children: [
    //     {
    //       path: '',
    //       components: {
    //         wait: () => import('@/views/staff/components/staff_q_wait'),
    //         giveup: () => import('@/views/staff/components/staff_q_giveup'),
    //         already: () => import('@/views/staff/components/staff_q_already')
    //       }
    //     }
    //   ]
    // }, {
    //   path: 'detail/:id',
    //   name: 'staffdetail',
    //   component: () => import('@/views/staff/staffdetail')
    // }, {
    //   path: 'add',
    //   name: 'staffadd',
    //   component: () => import('@/views/staff/staffadd')
    // }, {
    //   path: 'update/:id',
    //   name: 'staffupdate',
    //   component: () => import('@/views/staff/staffadd')
    // }
  ]
}

export default SataffRouter
